module.exports = __webpack_public_path__ + "static/media/splotch.aa5c17cb.svg";